<template lang="pug">
  .modal-wrapper
    .modal-overlay(@click="close")
    .modal-container#modal(
      :class="{'modal-container--right': position === 'right'}"
    )
      .modal-content
        slot
</template>

<script>
export default {
  name: 'modal-base',
  props: {
    position: {
      type: String
    }
  },
  mounted () {
    document.querySelector('body').style = 'overflow: hidden;'
  },
  destroyed () {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    close () {
      this.$emit('toggle', false)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/style/_variables";

.modal-wrapper {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
}

.modal-overlay {
  background-color: rgba(0, 0, 0, 0.48);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.modal-container {
  background-color: white;
  border-radius: 8px;
  box-shadow:  0 2px 4px 0 rgba(0, 0, 0, 0.2);
  margin: 0 16px;
  z-index: 1;
  overflow: hidden;

  &--right {
    position: fixed;
    right: 0;
    top: 20%;
    bottom: 0;
    width: 100%;
    border-radius: 0;
    margin: 0;
    border-radius: 12px 12px 0px 0px;

    @media screen and (min-width: 1366px) {
      top: 0;
      width: 387px;
      border-radius: unset;
    }
  }
}

.modal-close-button {
  width: 32px;
  height: 32px;
  float: right;
  cursor: pointer;
  color: white;
  font-size: 20px;
  margin: 16px 16px 0 0;
  border: none;
  background-color: transparent;

  > img {
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
}
</style>
